<template>
  <div>
    <h1 class="page-titles text-center">{{ titles }}</h1>
  </div>
</template>

<script>
export default {
  name: "pageTitle",
  props: ["titles"]
}
</script>

<style scoped>

</style>